<script lang="ts">
  import { ResponsiveVars, TwistStack } from '@twist/core';
  import Times from '@twist/icons/lib/Times.svg?component';
  import Modal from '$components/Modals/Modal.svelte';
  import AccessibilityControls from '$components/Accessibility/Modal/AccessibilityControls.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';

  const responsiveVars = new ResponsiveVars()
    .addFluid('header-font-size', toFluidVarInput(16, 24))
    .addFluid('paragraph-font-size', toFluidVarInput(12, 18))
    .addFluid('paragraph-mt', toFluidVarInput(24, 27))
    .addFluid('paragraph-mb', toFluidVarInput(64, 72))
    .toCSS();
</script>

<Modal
  modalKey="accessibility"
  size="sm"
  ariaLabel="Accessibility Controls"
  let:onCloseClicked={handleCloseClicked}
>
  <div class={cx(responsiveVars, 'wrapper')}>
    <TwistStack direction="row" align="center" justify="space-between">
      <h3 class="accessibility-header h3">Accessibility</h3>

      <button
        tabindex="0"
        class="close"
        aria-label="close accessibility settings"
        on:click={handleCloseClicked}
      >
        <Times />
      </button>
    </TwistStack>

    <p>Use the controls below to customize your web experience.</p>

    <AccessibilityControls />
  </div>
</Modal>

<style lang="scss">
  @import 'src/scss/media';

  .wrapper {
    padding: 24px;
    height: 100%;
    border-radius: 12px;
    background: var(--twist-color-gray-100);

    @include at('sm') {
      padding: 40px;
    }
  }

  h3.accessibility-header {
    font-size: var(--header-font-size);
    font-family: var(--font-family-primary);
    color: var(--twist-color-gray-0);
    font-weight: 600;
    line-height: 125%;
    margin: 0;
  }

  button {
    appearance: none;
    border: none;
    background: none;
    color: white;
    cursor: pointer;
    padding: 0;

    :global(svg) {
      width: 24px;
      height: 24px;
    }
  }

  p {
    font-family: var(--font-family-primary);
    font-weight: 500;
    line-height: 150%;
    color: var(--twist-color-gray-0);
    margin: var(--paragraph-mt) 0 var(--paragraph-mb);
    font-size: var(--paragraph-font-size);
  }
</style>
